
<template>
  <div>
      <el-form :model="information" :rules="rules" ref="information" label-width="100px" class="demo-ruleForm"  >
          <el-row class='registration'>
                <el-row class='registration_infor'>
                    <el-collapse v-model='activeNames'>
                        <el-collapse-item name='1' class='basic_information'>
                            <template slot='title'>
                                <svg-icon  icon-class='people_list'  class="registration_title_svg1" ></svg-icon>
                                <span class='registration_title'>基本信息</span>
                            </template>
                            <el-row  class="line_infor cover">
                            </el-row>
                            <el-row :gutter='20' class="line_infor" style="padding-top:0;">
                                <el-col :span='8'>
                                    <el-row :gutter='20'> 
                                        <el-col :span='8' class='left_side' style="line-height:29px;">
                                            <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>是否复诊
                                        </el-col>
                                        <el-col :span='8' class='right_side radio_line_height'>
                                             <el-radio-group v-model='information.basic_information.revisit'
                                               @change="information.basic_information.revisit==='1'?dialog=true:null;">
                                                <el-radio label='1' :disabled = 'loading'>是</el-radio>
                                                <el-radio label='2' :disabled = 'loading'>否</el-radio>
                                            </el-radio-group>
                                        </el-col>
                                        <el-col :span='8' class='left_side' style="line-height: 30px;" v-if="currentUserRoleDepart.haveHis">
                                            <el-button type='primary' @click="HisDialog=true;Hissearch();" :loading="loading" size="small ">电子申请单</el-button> 
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side' style="line-height: 30px;">
                                            VIP
                                        </el-col>
                                        <el-col :span='16' class='right_side radio_line_height'>
                                            <el-radio v-model='information.data.isVip' :disabled = 'loading' label='true'>是</el-radio>
                                            <el-radio v-model='information.data.isVip' :disabled = 'loading' label='false'>否</el-radio>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>姓名
                                        </el-col>
                                            <el-col :span='16' class='right_side'>
                                                <el-form-item  prop="data.patient.name" >
                                                    <el-input :disabled = 'loading' v-model='information.data.patient.name' placeholder='' @change="changePinyin(information.data.patient.name)"></el-input>
                                                </el-form-item>
                                            </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            拼音姓名
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                                <el-input :disabled = 'loading' v-model='information.data.patient.pyCode' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>性别
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select :disabled = 'loading' v-model="information.data.patient.sex" >
                                                <el-option  value='男'>男</el-option>
                                                <el-option  value='女'>女</el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            民族
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-input :disabled = 'loading' v-model='information.data.patient.nation' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            出生日期
                                        </el-col>
                                        <el-col :span='16' class='right_side date'>
                                            <el-date-picker :disabled = 'loading' v-model='information.data.patient.birthDate' type='date' 
                                            value-format="yyyy-MM-dd">
                                            </el-date-picker>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>年龄
                                        </el-col>
                                        <el-col :span='8' class='right_side' style="padding-right:5px;">
                                             <el-form-item  prop="data.patient.age" >
                                                <el-input :disabled = 'loading' v-model='information.data.patient.age' placeholder=''></el-input>
                                             </el-form-item>
                                        </el-col>
                                        <el-col :span='8' class='right_side' style="padding-left:5px;">
                                            <el-select :disabled = 'loading' v-model="information.data.patient.ageUnit" >
                                                <el-option v-for="item in options" :key="item.value" 
                                                :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            电话
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-input :disabled = 'loading'  v-model='information.data.patient.phoneNo' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                          身高
                                        </el-col>
                                        <el-col :span='12' class='right_side' style="padding-right:0;">
                                            <el-input :disabled = 'loading'  v-model='information.data.patient.height' placeholder=''></el-input>
                                        </el-col>
                                        <el-col :span='4' class='right_side body_infor_height' >
                                            <el-input value="CM" disabled ></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8' >
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                          体重
                                        </el-col>
                                        <el-col :span='12' class='right_side' style="padding-right:0;">
                                            <el-input :disabled = 'loading' v-model='information.data.patient.weight' placeholder=''></el-input>
                                        </el-col>
                                        <el-col :span='4' class='right_side body_infor_height'>
                                            <el-input  value="KG" :disabled="true"></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <div class="all_line_left">
                                    现住地址
                                </div>
                                <div class="all_line_right" style="width:54.83333333%;">
                                    <el-input :disabled = 'loading' v-model='information.data.patient.address' placeholder=''></el-input>
                                </div>
                            </el-row>
                        </el-collapse-item>
                           <el-collapse-item name='2' class='apply_information'>
                            <template slot='title'>
                                 <svg-icon  icon-class='checkInfor'  class="registration_title_svg2"></svg-icon>
                                <span class="registration_title">申请信息</span>
                            </template>
                            <el-row  class="line_infor cover">
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20' >
                                        <el-col :span='8' class='left_side'>
                                           <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>是否急诊
                                        </el-col>
                                        <el-col :span='16' class='right_side radio_line_height'>
                                            <el-radio :disabled = 'loading' v-model='information.data.emergency' label='true'>是</el-radio>
                                            <el-radio :disabled = 'loading' v-model='information.data.emergency' label='false'>否</el-radio>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter='20' class="line_infor"> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                           <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>患者来源
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select  :disabled = 'loading' v-model="information.data.patientSource" >
                                                <el-option v-for="item in dict.patientSource" :key="item.id" 
                                                :label="item.dictName" :value="item.dictName">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side' v-if="information.data.patientSource ==='住院'">
                                            住院号
                                        </el-col>
                                        <el-col :span='8' class='left_side' v-else>
                                            门诊号
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <template v-if="information.data.patientSource ==='住院'">
                                                <el-input :disabled = 'loading' v-model='information.data.inpatientNo' placeholder=''></el-input>
                                            </template>
                                            <template v-else>
                                                <el-input :disabled = 'loading' v-model='information.data.outpatientNo' placeholder=''></el-input>
                                            </template>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                           <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>申请科室
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select   :disabled = 'loading' :loading = 'loadingSelect' v-model="information.data.applyDepart" >
                                                <el-option v-for="item in departments" :key="item.id" 
                                                :label="item.name" :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                          申请医生
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-input   :disabled = 'loading' v-model='information.data.applyDoctor ' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            申请单号
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                          <el-input   :disabled='loading || His'  v-model='information.data.regNo' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            病区号
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-input   :disabled = 'loading'  v-model='information.data.inpatientArea' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            床位号
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-input   :disabled = 'loading' v-model='information.data.bedNo' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            患者类型
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                          <el-select   :disabled = 'loading' v-model="information.data.patientType" >
                                                <el-option v-for="item in dict.patinentType" :key="item.id" 
                                                :label="item.dictName" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            诊疗类型
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select  :disabled = 'loading'  v-model="information.data.diagClassic " >
                                                <el-option v-for="item in dict.treatmentType" :key="item.id" 
                                                :label="item.dictName" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <div class="all_line_left" >
                                    <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>病史
                                </div>
                                <div class="all_line_right">
                                    <el-form-item  prop="data.presentIllness" >
                                        <el-input  :disabled = 'loading'  v-model='information.data.presentIllness' placeholder=''></el-input>
                                    </el-form-item >
                                </div>
                            </el-row> 
                        </el-collapse-item>
                        <el-collapse-item  name='3' class='check_information'>
                            <template slot='title'>
                                    <svg-icon  icon-class='文件信息'  class="registration_title_svg3" ></svg-icon>
                                    <span class="registration_title">检查信息</span>
                            </template>
                            <el-row  class="line_infor cover">
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>设备类型
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-form-item  prop="check_information.check_type" >
                                                <el-select  :loading= 'loadingSelect' :disabled = 'loading' v-model="information.check_information.check_type" 
                                                @change="getBody(information.check_information.check_type)">
                                                    <el-option v-for="item in checkList.checkType" :key="item.id" 
                                                    :label="item.name"
                                                     :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                             <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>检查部位
                                        </el-col>
                                        <el-col :span='16' class='right_side' >
                                            <el-form-item  prop="check_information.check_body" >
                                                <el-select  :loading= 'loadingSelect' :disabled = 'loading' v-model="information.check_information.check_body" no-data-text ="请先选择设备类型"
                                                @change="getItemname(information.check_information.check_body)" >
                                                    <el-option v-for="item in checkList.checkBody" :key="item.id" 
                                                    :label="item.name" :value="item.id" >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span='3' class="body_infor_height body_tip_connent">
                                          <el-popover  width="550" trigger="hover" placement="top">
                                            <el-row>
                                              <el-col :span="24" class="body_tips_header">
                                                部位数据提示
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">头部:</span>   
                                                鼻，耳，口，颅脑，面部，咽喉，眼 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">颈部:</span>   
                                                甲状腺，气管，上消化道，食道 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">胸部:</span>   
                                                肺，膈肌，乳房，食管，心脏 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">腹部:</span>   
                                                肠，肝，胆，腹膜，肠系膜，阑尾，胃，脾，胰腺 
                                              </el-col><el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">腰部:</span>   
                                                肾，肾上腺，输尿管 
                                              </el-col><el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">臀部:</span>   
                                                肛门
                                              </el-col><el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">上肢:</span>   
                                                肩部，前臂，上臂，手部，肘部 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">下肢:</span>   
                                                大腿，膝部，小腿，足部 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">骨骼:</span>   
                                                <span>骨髓，关节，脊髓，脊柱，肋骨，颅骨，盆骨，上肢骨，下肢骨，其他骨</span> 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">盆腔:</span>   
                                                膀胱，尿道 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">生殖系统:</span>   
                                                睾丸，前列腺，阴囊，阴茎，输精管，会阴部，卵巢，输卵管，外阴，阴道，子宫 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">血管系统:</span>   
                                                所有血管 
                                              </el-col>
                                              <el-col :span="24" class="body_tips_connent">
                                                <span class="body_tips_position">其他:</span>   
                                                肌肉，淋巴，免疫系统，皮肤，神经系统，其他 
                                              </el-col>
                                            </el-row>
                                            <div slot="reference" class="body_tips" style="cursor: pointer;display:none;">
                                              <el-input value="?" :disabled="true" ></el-input>
                                            </div>
                                          </el-popover>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                          <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>检查项目
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-form-item  prop="check_information.itemName" >
                                                <el-select :loading= 'loadingSelect'  :disabled = 'loading' v-model="information.check_information.itemName" no-data-text ="请先选择检查部位">
                                                        <el-option v-for="item in checkList.checkProject" :key="item.id" 
                                                        :label="item.itemName" :value="item.id" >
                                                        </el-option>
                                                </el-select>
                                            </el-form-item >
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            扫描类型  
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select   :disabled = 'loading' v-model="information.check_information.scanMode" >
                                                    <el-option v-for="item in dict.scanningtType" :key="item.id" :label="item.dictName" :value="item.dictName">
                                                    </el-option>
                                                </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                              <span  class="red_color"><img src="~@/assets/star.png" alt=""></span>影像室
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-form-item  prop="check_information.image_room" >
                                                <el-select  :loading= 'loadingSelect' :disabled = 'loading' v-model="information.check_information.image_room" no-data-text ="请先选择设备类型">
                                                    <el-option v-for="item in imageRoom" :key="item.id" 
                                                    :label="item.examRoom" :value="item.id" >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side' style="opacity: 0;">
                                            123
                                        </el-col>
                                        <el-col :span='16' class='right_side confirm_bnt' style="text-align:right;">
                                            <el-button :disabled = 'loading' type='success' icon="el-icon-circle-plus-outline"  @click="add_infor(information)" size="mini" >确认添加</el-button>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row class="add_infor" style="margin-top:10px;">
                                <el-table :data="tableData" style="width: 100%"  empty-text="请确认添加检查信息" size="mini" stripe  >
                                    <el-table-column type="index" label="序号" width="80" header-cell-class-name="indexNum"></el-table-column>
                                    <el-table-column prop="check_type"  label="设备类型"></el-table-column>
                                    <el-table-column prop="check_body" label="部位分组" :show-overflow-tooltip = 'true'></el-table-column>
                                    <el-table-column prop="itemName"  label="检查项目" :show-overflow-tooltip = 'true'></el-table-column>
                                    <el-table-column prop="image_room" label="影像室"></el-table-column>
                                    <el-table-column prop="money"  label="金额"></el-table-column>
                                    <el-table-column label="检查日期" width="250">
                                        <template slot-scope="scope">
                                            <el-date-picker v-model="scope.row.check_time" type="datetime" placeholder="选择日期时间"
                                            value-format="yyyy-MM-dd HH:mm:ss" align="right" :picker-options="pickerOptions1">
                                            </el-date-picker>
                                        </template> 
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <span  @click="del(scope.$index)">
                                                <svg-icon  icon-class='delete' class="delImg" ></svg-icon>
                                            </span>    
                                        </template>
                                    </el-table-column>
                                </el-table>
                        </el-row>
                        </el-collapse-item>
                          <el-collapse-item  name='4' class='detail_information'>
                             <el-row  class="line_infor cover" >
                            </el-row>
                            <template slot='title'>
                                <svg-icon  icon-class='detailInfor'  class="registration_title_svg4"></svg-icon>
                                <span class="registration_title">详细信息</span>
                            </template>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            证件类型  
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select :disabled = 'loading' v-model="information.data.patient.certType" >
                                                <el-option v-for="item in card_type_arr" :key="item.value" 
                                                :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            证件号
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <!-- card_num:  -->
                                            <el-input :disabled = 'loading' v-model='information.data.patient.certNo' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                                籍贯
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select :disabled = 'loading' v-model="information.data.patient.native" >
                                                <el-option v-for="item in dict.nativePlace" :key="item.id" 
                                                :label="item.dictName" :value="item.dictName">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            职业  
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select :disabled = 'loading' v-model="information.data.patient.employment" >
                                                    <el-option v-for="item in occupation_arr" :key="item.value" 
                                                    :label="item.label" :value="item.value">
                                                    </el-option>
                                            </el-select>       
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            婚姻状况
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                            <el-select :disabled = 'loading' v-model="information.data.patient.wedlock" >
                                                    <el-option value="已婚">已婚</el-option>
                                                    <el-option value="未婚">未婚</el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </el-col> 
                                <el-col :span='8'>
                                    <el-row :gutter='20'>
                                        <el-col :span='8' class='left_side'>
                                            临床诊断
                                        </el-col>
                                        <el-col :span='16' class='right_side'>
                                                <el-input :disabled = 'loading' v-model='information.data.diagnosis' placeholder=''></el-input>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter='20' class="line_infor">
                                <div class="all_line_left" style="float: left;">
                                    既往史
                                </div>
                                <div class="all_line_right">
                                    <el-input :disabled = 'loading' v-model='information.data.pastHistory' type="textarea" placeholder=''></el-input>
                                </div>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-row> 
                <el-row  class="footer">
                    <el-col :span='4' :offset='10' class="submit_button">
                      <el-button type='primary' @click="submit" :loading="loading" size="small ">提交登记</el-button> 
                    </el-col>
                </el-row>
                  <!-- 是否复诊弹窗-->
                <el-dialog title="选择患者" :visible.sync="dialog" width="700px"  custom-class='revisitDialog' ref="dialog" @open="open()" @close="close()">
                    <el-row :gutter='20' class="line_infor search"> 
                        <el-col :span='3' style="line-height: 30px;">
                            <span class="registration_title" style="padding-left:0;">患者姓名</span>
                        </el-col>
                        <el-col :span='10' style="padding-left:0;">
                            <el-input v-model='searchName' placeholder='请输入患者姓名'></el-input>
                        </el-col>
                        <el-col :span='2'  class="search_btn">
                        <el-button type='primary' @click="search" size="mini" icon="el-icon-search">查询</el-button> 
                        </el-col>        
                     </el-row>
                     <el-row style="margin-top:20px;">
                        <el-table :data="tableData2"   style="width: 100%" empty-text="暂无信息" stripe size='mini' v-loading="loading" height="400">
                            <el-table-column prop="name" label="姓名" width="80px"></el-table-column>
                            <el-table-column prop="sex" label="性别" width="50px"></el-table-column>
                            <el-table-column prop="birthDate" label="生日" width="100px"></el-table-column>
                            <el-table-column prop="phoneNo" label="手机号"  width="100px"></el-table-column>
                            <el-table-column prop="certType" label="证件类型"  width="80px"></el-table-column>
                            <el-table-column  prop="certNo"  label="证件号" width="150px">
                            </el-table-column>
                            <el-table-column  label="功能"  >
                                <template slot-scope="scope">
                                    <el-button type="success" icon="el-icon-check" circle size="mini" @click="setValue(scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table> 
                     </el-row>
                </el-dialog>  
                <el-dialog title="选择患者" :visible.sync="HisDialog" width="80%"  custom-class='revisitDialog' ref="dialog" @open="open()" @close="close()">
                     <el-row :gutter='20' class=""> 
                        <el-col :span='3' style="line-height: 30px;">
                            <span class="" style="padding-left:0;">搜索</span>
                        </el-col>
                        <el-col :span='8' style="padding-left:0;">
                            <el-input v-model='HissearchName' placeholder='请输入姓名/申请单号等条件'></el-input>
                        </el-col>
                        <el-col :span='3' style="line-height: 30px;">
                            <span class="" style="padding-left:0;">时间</span>
                        </el-col>
                        <el-col :span='6' style="padding-left:0;">
                          <el-radio-group v-model="timeType" size="mini">
                            <el-radio-button
                              v-for="item in getTime"
                              :key="item.Value"
                              :label="item.Value"
                            >{{item.Text}}</el-radio-button>
                          </el-radio-group>
                        </el-col>
                        <el-col :span='2'  class="search_btn">
                        <el-button type='primary' @click="Hissearch()" size="mini" icon="el-icon-search">查询</el-button> 
                        </el-col>        
                     </el-row>
                     <el-row style="margin-top:20px;">
                        <el-table :data="HisRegisterList" style="width: 100%" empty-text="暂无信息" stripe size='mini' highlight-current-row @current-change="handleCurrentChange1" v-loading="loading" height="400">
                            <el-table-column prop="studyId" label="申请单号" width="100px"></el-table-column>
                            <el-table-column prop="patName" label="姓名" width="120px"></el-table-column>
                            <el-table-column prop="scheduledDate" label="申请时间" width="120px"></el-table-column>
                            <el-table-column prop="examClass" label="检查类型" width="80"></el-table-column>
                            <el-table-column prop="examSubClass" label="检查项目" width="120px"></el-table-column>
                            <el-table-column prop="sex" label="性别" width="80px"></el-table-column>
                            <el-table-column prop="birthDate" label="生日" width="140px">
                              <template slot-scope="scope">
                                  {{scope.row.birthDate | birthDates}}
                              </template>
                            </el-table-column>
                            <el-table-column prop="hkTele" label="手机号" width="140px"></el-table-column>
                            <el-table-column prop="sfzNo"  label="证件号" width="180px"></el-table-column>
                            <el-table-column prop=""  label="患者来源" width="80">
                              <template slot-scope="scope">
                                <span v-if='scope.row.patientSource == 1'>门诊</span>
                                <span v-else-if='scope.row.patientSource == 2'>住院</span>
                                <span v-else>其他</span>
                              </template>
                            </el-table-column>
                        </el-table> 
                     </el-row>
                     <div slot="footer" class="dialog-footer">
                      <el-button type="primary" size='mini' style="" @click="HissetValue(fillInfor1)"> 确 定 </el-button>
                    </div>
                </el-dialog>
          </el-row>
      </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ConvertPinyin } from '@/utils/changepinyin'
import { formatDateTime } from '@/utils/formatDateTime'
import { formatDate } from '@/utils/index.js'
import dupContent from '@/utils/dupContent.js'
import common from '@/utils/common.js'
export default {
  name: 'Registration',
  data() {
    return {
      getTime: common.SettingsTimes.value,
      fillInfor1: '',
      timeType: 0,
      His: false,
      beginDate: '',
      endDate: '',
      dialog: false,
      HisDialog: false,
      loading: false,
      loadingSelect: false,
      searchName: '',
      HissearchName: '',
      nowHistory: '',
      tableData2: [],
      information: {
        data: {
          departId: '', // 科室ID
          regNo: null, // 申请单编号 编辑页面需要
          patient: {
            patientNo: null, // 患者ID
            name: '', // 姓名
            pyCode: '', // 拼音名字
            sex: '男', // 性别
            birthDate: '', // 出生日期
            age: '', // 年龄
            nation: '汉', // 民族
            native: '', // 籍贯省
            wedlock: '未婚', // 结婚
            certType: '身份证',
            certNo: '',
            address: '',
            phoneNo: '',
            height: '',
            weight: '',
            employment: '未定义', // 职业
            ageUnit: '岁'
          },
          emergency: 'false',
          cardNo: null, // 就诊卡号暂无
          inpatientNo: null, // 住院号暂无
          inPatientCount: 0, // 住院次数暂无
          bedNo: '', // 床位号
          outpatientNo: null, // 门诊号暂无
          medicalId: null, // 病案号暂无
          patientSource: '', // 患者来源
          applyDepart: '', // 申请科室
          applyDoctor: '', // 申请医生
          applyDt: '', // 申请时间 暂无
          inpatientArea: null, // 病区暂无
          diagnosis: '', // 临床诊断
          pastHistory: '', // 历史病史
          presentIllness: '', // 现病史
          memo: null, // 备注
          isVip: 'false', // vip
          register: '', // 登记操作人员
          registerId: '', // 登记人ID
          patientType: '', // 患者类型
          diagClassic: '', // 诊疗类别
          Items: [// 添加患者数据
          // {
          //   itemId: '0B64AF10-F1D0-6CD0-647F-160C50326F9D',//检查项目
          //   itemName: '胸部平扫',
          //   bodyPartGroup:'',
          //   itemPrice: 32,
          //   checkType: '', // 设备类型id
          //   adveiceId: null, // 医嘱编号暂无
          //   studyUid: null, // 影像编号补登暂无
          //   apptDt: '2018-08-15 12:40:00',
          //   scanMode: 'value', // 扫描id
          //   deviceId: '0B64AF10-F1D0-6CD0-647F-160C50326F9D' // 设备id
          // }
          ]

        },
        // 基本信息
        basic_information: {
          revisit: '2' // 是否复诊
        },
        // 检查信息
        check_information: {
          check_type: '', // 设备类型
          check_body: '', // 检查部位
          itemName: '', // 检查项目
          scanMode: '', // 扫描类型
          image_room: '' // 影像室,
        }
      },
      rules: { // 校验规则
        data: {
          patient: {
            name: [
              { required: true, message: '', trigger: 'change' }
            ],
            age: [
              { required: true, message: '', trigger: 'change' }
            ]
          },
          presentIllness: [
            { required: true, message: '', trigger: 'change' }
          ]
        },
        check_information: {
          check_type: [
            { required: false, message: '', trigger: 'change' }
          ], // 设备类型
          check_body: [
            { required: false, message: '', trigger: 'change' }
          ], // 检查部位
          itemName: [
            { required: false, message: '', trigger: 'change' }
          ], // 检查项目
          image_room: [
            { required: false, message: '', trigger: 'change' }
          ]// 影像室
        }
      },
      activeNames: ['1', '2', '3'], // 折叠版默认值
      pickerOptions1: {
        shortcuts: [{
          text: '当前',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      options: dupContent.options.value,
      card_type_arr: dupContent.card_type_arr.value,
      occupation_arr: dupContent.occupation_arr.value,
      tableData: [] // 添加患者检查数据
    }
  },
  inject: ['reload'],
  components: {
  },
  filters: {
    birthDates(datas) {
      if (datas) {
        return datas.slice(0, 4) + '-' + datas.slice(4, 6) + '-' + datas.slice(6, 8)
      } else {
        return ''
      }
    }
  },
  watch: {
    timeType(type) {
      this.checkTimeType(type)
    }
  },
  computed: {
    ...mapGetters(['hospitals', 'name', 'userId', 'departId', 'departments',
      'dict', 'checkList', 'imageRoom', 'currentUserRoleDepart', 'patients', 'HisRegisterList'])
  },
  mounted() {
    // 默认值
    this.information.data.register = this.name // 登记操作人员
    this.information.data.registerId = this.userId // 登记操作人员ID
    this.information.data.departId = this.departId // 科室ID
    // 下拉
    this.getChecktype()// 设备类型下拉
    this.getDepartments()// 申请科室下拉
    // 页面默认值
    this.information.data.patientSource = this.dict.patientSource[0].dictName // 患者来源默认
    this.information.check_information.scanMode = this.dict.scanningtType[0].dictName // 扫描类型
    this.beginDate = formatDate(new Date(), 'yyyy-MM-dd')
    this.endDate = formatDate(new Date(), 'yyyy-MM-dd')
  },
  methods: {
    open() { // 复诊弹窗开启
    },
    close() {
      if (this.tableData2.length === 0) {
        this.information.basic_information.revisit = '2'
      } else {
        this.information.basic_information.revisit = '1'
      }
    },
    handleCurrentChange1(val) {
      this.fillInfor1 = val
    },
    checkTimeType(type) {
      if (type === 0) {
        this.beginDate = formatDate(new Date(), 'yyyy-MM-dd')
        this.endDate = formatDate(new Date(), 'yyyy-MM-dd')
      }
      if (type === 2) {
        this.beginDate = formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd')
        this.endDate = formatDate(new Date(), 'yyyy-MM-dd')
      }
      this.Hissearch()
    },
    // 复诊查询
    search() {
      if (this.searchName === '') {
        this.$message({ message: '请输入姓名', type: 'warning' })
        return
      }
      this.$store.dispatch('patients', { hospId: this.currentUserRoleDepart.hospId, patientName: this.searchName }).then(() => {
        if (this.patients.length === 0) {
          this.$message('查无此人')
        } else {
          this.tableData2 = null
          this.tableData2 = this.patients
        }
      }).catch(() => {
      })
    },
    setValue(value) {
      this.information.data.patient = value
      this.dialog = false
    },
    Hissearch() {
      this.$store.dispatch('getHisRegisters', { departId: this.currentUserRoleDepart.departId, beginDate: this.beginDate, endDate: this.endDate, filter: this.HissearchName }).then(() => {
      }).catch(() => {
      })
    },
    HissetValue(value) {
      this.information = {
        data: {
          departId: this.currentUserRoleDepart.departId, // 科室ID
          regNo: value.studyId, // 申请单编号 编辑页面需要
          patient: {
            patientNo: value.Patient_id, // 患者ID
            name: value.patName, // 姓名
            pyCode: '', // 拼音名字
            sex: value.sex, // 性别
            birthDate: '', // 出生日期
            age: value.age, // 年龄
            nation: '汉', // 民族
            native: '', // 籍贯省
            wedlock: '未婚', // 结婚
            certType: '身份证',
            certNo: value.sfzNo,
            address: value.hkAddr,
            phoneNo: value.hkTele,
            height: '',
            weight: '',
            employment: '未定义', // 职业
            ageUnit: value.ageType
          },
          emergency: 'false',
          cardNo: value.cardNo, // 就诊卡号暂无
          inpatientNo: value.hspNo, // 住院号暂无
          inPatientCount: 0, // 住院次数暂无
          bedNo: value.bedNo, // 床位号
          outpatientNo: value.mzNo, // 门诊号暂无
          medicalId: null, // 病案号暂无
          patientSource: '', // 患者来源
          applyDepart: value.department, // 申请科室
          applyDoctor: value.doctor, // 申请医生
          applyDt: value.scheduledDate, // 申请时间 暂无
          inpatientArea: value.wardNo, // 病区暂无
          diagnosis: value.clinDiag, // 临床诊断
          pastHistory: '', // 历史病史
          presentIllness: value.clinSymp + value.physSign + value.clinDiag + value.relevantDiag + value.relevantLabTest + value.notice, // 现病史
          memo: null, // 备注
          isVip: 'false', // vip
          register: '', // 登记操作人员
          registerId: '', // 登记人ID
          patientType: value.jzCode, // 患者类型
          diagClassic: '', // 诊疗类别
          Items: [// 添加患者数据
          ]

        },
        // 基本信息
        basic_information: {
          revisit: '2' // 是否复诊
        },
        // 检查信息
        check_information: {
          check_type: value.examClass, // 设备类型
          check_body: value.examSubClass, // 检查部位
          itemName: value.chkitName, // 检查项目
          scanMode: '', // 扫描类型
          image_room: '' // 影像室,
        }
      }
      for (var i = 0; i < this.departments.length; i++) {
        if (this.departments[i].name !== this.information.data.applyDepart) {
          this.information.data.applyDepart = this.departments[0].name
        } else {
          this.information.data.applyDepart = this.departments[i].name
          break
        }
      }
      for (var i = 0; i < this.dict.patinentType.length; i++) {
        if (this.dict.patinentType[i].name !== this.information.data.patientType) {
          this.information.data.patientType = ''
        } else {
          this.information.data.patientType = this.dict.patinentType[i].id
          break
        }
      }
      for (var i = 0; i < this.checkList.checkType.length; i++) {
        if (this.checkList.checkType[i].name !== this.information.check_information.check_type) {
          this.information.check_information.check_type = this.checkList.checkType[0].id
          this.getBody(this.checkList.checkType[0].id)
        } else {
          this.information.check_information.check_type = this.checkList.checkType[i].id
          this.getBody(this.checkList.checkType[i].id)
          break
        }
      }
      for (var i = 0; i < this.checkList.checkBody.length; i++) {
        if (this.checkList.checkBody[i].name !== this.information.check_information.check_body) {
          this.information.check_information.check_body = this.checkList.checkBody[0].id
          this.getItemname(this.checkList.checkBody[0].id)
        } else {
          this.information.check_information.check_body = this.checkList.checkBody[i].id
          this.getItemname(this.checkList.checkBody[i].id)
          break
        }
      }
      for (var i = 0; i < this.checkList.checkProject.length; i++) {
        if (this.checkList.checkProject[i].name !== this.information.check_information.itemName) {
          this.information.check_information.itemName = this.checkList.checkProject[0].id
        } else {
          this.information.check_information.itemName = this.checkList.checkProject[i].id
          break
        }
      }
      if (value.patientSource === 1) {
        this.information.data.patientSource = '门诊'
      } else if (value.patientSource === 2) {
        this.information.data.patientSource = '住院'
      } else {
        this.information.data.patientSource = '其他'
      }
      if (value.studyId) {
        this.His = true
      }
      this.information.data.patient.birthDate = new Date(value.birthDate.slice(0, 4) + '-' + value.birthDate.slice(4, 6) + '-' + value.birthDate.slice(6, 8))
      // this.ageCount(this.information.data.patient.birthDate)
      this.information.data.register = this.name // 登记操作人员
      this.information.data.registerId = this.userId // 登记操作人员ID
      this.information.data.departId = this.departId // 科室ID
      this.changePinyin(this.information.data.patient.name)
      this.HisDialog = false
    },
    // ageCount(birthDate) {
    //   var agedate = formatDate(new Date(), 'yyyy-MM-dd')
    //   var agedateyear = parseInt(agedate.slice(0, 4))
    //   var agedateMonth = parseInt(agedate.slice(5, 7))
    //   var agedateday = parseInt(agedate.slice(8, 10))
    //   console.log(agedateyear, agedateMonth, agedateday)
    // },
    // 获取设备类型
    getChecktype() {
      this.loadingSelect = true
      this.$store.dispatch('getcheckType', { departId: this.departId }).then(() => {
        this.loadingSelect = false
      }).catch(() => {
        this.$message({ message: '获取设备类型失败，请重新获取', type: 'warning' })
        this.loadingSelect = false
      })
    },
    // 获取科室
    getDepartments() { // 获取申请科室列表
      this.loadingSelect = true
      this.$store.dispatch('getdepartment', { hospId: this.currentUserRoleDepart.hospId, departType: 2 }).then(() => {
        if (this.departments) {
          this.information.data.applyDepart = this.departments[0].name // 申请科室默认值
        }
        this.loadingSelect = false
      }).catch(() => {
        this.$message({ message: '获取申请科室列表失败，请重新获取', type: 'warning' })
        this.loadingSelect = false
      })
    },
    changePinyin(value) { // 转拼音
      this.information.data.patient.pyCode = ConvertPinyin(value).toUpperCase()
    },
    // 获取检查部位
    getBody(value) {
      this.loadingSelect = true
      this.information.check_information.check_body = ''
      this.information.check_information.itemName = ''
      this.information.check_information.image_room = ''
      var temp = null
      for (let index = 0; index < this.checkList.checkType.length; index++) {
        if (this.checkList.checkType[index].id === value) {
          temp = this.checkList.checkType[index].modality
          break
        }
      }
      this.getImageroom()// 获取影像室
      this.$store.dispatch('getcheckBody', { departId: this.departId, modality: temp }).then(() => {
        this.loadingSelect = false
      }).catch(() => {
        this.loadingSelect = false
        this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
      })
    },
    getItemname(value) {
      this.information.check_information.itemName = ''
      this.loadingSelect = true
      this.$store.dispatch('getcheckProject', { partGroupId: value }).then(() => {
        this.loadingSelect = false
      }).catch(() => {
        this.loadingSelect = false
        this.$message({ message: '获取检查项目失败，请重新获取', type: 'warning' })
      })
    },
    // 获取影像科室
    getImageroom() {
      this.loadingSelect = true
      this.$store.dispatch('getimageRoom', { departId: this.departId, deviceType: this.information.check_information.check_type }).then(() => {
        this.loadingSelect = false
      }).catch(() => {
        this.loadingSelect = false
        this.$message({ message: '获取影像室失败，请重新获取', type: 'warning' })
      })
    },
    add_infor(information) { // 添加登记信息
      // 校验过程
    //   this.$refs.information.validateField('check_information.check_type')
    //   this.$refs.information.validateField('check_information.check_body')
    //   this.$refs.information.validateField('check_information.itemName')
    //   this.$refs.information.validateField('check_information.image_room')
      // 检查信息非空校验
      if (!this.information.check_information.check_type ||
            !this.information.check_information.check_body ||
            !this.information.check_information.itemName ||
            !this.information.check_information.image_room
      ) {
        this.$message({ showClose: true, message: '请将检查信息的必填信息填写完整', type: 'warning' })
        return
      }
      // 重复添加校验
      var temp = {} // 需要新添加信息的临时变量
      for (let index = 0; index < this.checkList.checkType.length; index++) {
        if (this.information.check_information.check_type === this.checkList.checkType[index].id) {
          temp.check_type = this.checkList.checkType[index].name
        }
      }
      for (let index = 0; index < this.checkList.checkBody.length; index++) {
        if (this.information.check_information.check_body === this.checkList.checkBody[index].id) {
          temp.check_body = this.checkList.checkBody[index].name
        }
      }
      for (let index = 0; index < this.checkList.checkProject.length; index++) {
        if (this.information.check_information.itemName === this.checkList.checkProject[index].id) {
          temp.itemName = this.checkList.checkProject[index].itemName
          temp.money = this.checkList.checkProject[index].itemPrice
        }
      }
      for (let index = 0; index < this.imageRoom.length; index++) {
        if (this.information.check_information.image_room === this.imageRoom[index].id) {
          temp.image_room = this.imageRoom[index].examRoom
        }
      }
      if (this.tableData.length) {
        for (let index = 0; index < this.tableData.length; index++) {
          const a = this.tableData[index]
          var b = this.tableData[index].check_time// 将检查日期保存起来
          delete a.check_time // ***剔除检查时间避免重复添加校验失效
          if (JSON.stringify(a) === JSON.stringify(temp)) {
            this.$message({ showClose: true, message: '请不要添加重复信息', type: 'warning' })
            this.tableData[index].check_time = b // 归还属性检查日期
            return
          }
          this.tableData[index].check_time = b // 归还属性检查日期
        }
      }
      temp.check_time = new Date() // ***最后添加时间避免重复添加校验失效
      this.tableData.push(temp)
      var temp3 = {}
      temp3.itemId = this.information.check_information.itemName // 影像科室ID
      temp3.itemName = temp.itemName // 影像科室名字
      temp3.bodyPartGroup = temp.check_body // 检查部位
      temp3.itemPrice = temp.money //  价钱
      temp3.checkType = this.information.check_information.check_type // 设备类型id
      temp3.apptDt = formatDateTime(temp.check_time)
      temp3.scanMode = this.information.check_information.scanMode // 扫描类型
      temp3.deviceId = this.information.check_information.image_room // 影像shi
      this.information.data.Items.push(temp3)
    },
    del(index) { // 删除登记信息
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        this.tableData.splice(index, 1)
        this.information.data.Items.splice(index, 1)
      }).catch(() => {
      })
    },
    submit() { // 提交
      if (this.tableData.length === 0) {
        this.$message({ showClose: true, message: '请添加检查相关信息', type: 'warning' })
        return false
      }
      this.$refs.information.validate((valid) => {
        if (!valid) {
          this.$message({ showClose: true, message: '请填写红色区域的必填信息', type: 'warning' })
        } else {
          this.$confirm('是否确定提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info '
          }).then(() => {
            this.loading = true
            this.$store.dispatch('saveRegistration', this.information.data).then(() => { // 提交登记
              this.loading = false
              this.submitLast() // 最后操作
            }).catch(() => {
              this.$message({ message: '提交失败', type: 'warning' })
              this.loading = false
            })
          })
        }
      })
    },
    submitLast() { // 是否继续填写
      this.$confirm('信息已成功提交,是否要继续添加信息', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success '
      }).then(() => {
        // 清空操作
        this.reload()
      }).catch(() => {
        this.$emit('eee', { index: '2' })
        this.reload()
      })
    }
  }
}
</script>